// SwiperCmn
//

import Swiper from 'swiper/bundle';

class SwiperCmn {
  constructor({ elm }) {
    this.swiper = new Swiper(elm, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1500,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: elm.querySelector("[data-role='cmn-swiper-next']"),
        prevEl: elm.querySelector("[data-role='cmn-swiper-prev']"),
      },
    });
  }
}

export default SwiperCmn;
